import { render, staticRenderFns } from "./textarea-primary.vue?vue&type=template&id=2bb81dca&scoped=true&"
import script from "./textarea-primary.vue?vue&type=script&lang=js&"
export * from "./textarea-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb81dca",
  null
  
)

export default component.exports